<template>
	<div>
		<BaseEmpty>
			<ChartFilters
				@findTransactions="search"
				style="margin-bottom: 0px"
				:showSelect="{
					grouping: true,
					category: true,
					month: true,
					year: true,
					type: true
				}"

			/>
		</BaseEmpty>
		<Base addWidth="30px" class="container" style="margin-top: 20px">
			<div>
				<ChartMedia
					:title="`Despesas por categorias`"
					:showXAxisLabel="true"
					:showZoom="true"
					:chartKey="3"
					:showLegend="true"
					:filters="filters"
				/>
			</div>
		</Base>
	</div>
</template>

<script>
	import Base from "@/templates/Base";
	import BaseEmpty from "@/templates/BaseEmpty.vue";
	import ChartMedia from "@/components/charts/ChartMedia.vue";
	import ChartFilters from "@/components/charts/ChartFilters.vue";

	export default {
		components: {
			ChartMedia,
			Base,
			ChartFilters,
			BaseEmpty
		},

		data () {
			return {
				filters: {}
			};
		},

		computed: {

		},

		watch: {
		},

		async mounted () {
		},

		methods: {
			search (filters) {
				this.filters = filters;
			}
		}
	};
</script>

<style scoped>
	.container {
		max-width: 90.5%;
	}
</style>
